module.exports = __webpack_public_path__ + "static/media/gastro-image1.34865345.png";